import Item from "./Item";
import { type UploaderFileListProps } from "./types";

const UploaderFileList = ({
  files,
  onDelete,
  onReselect,
  processing,
  listVariant = "default"
}: UploaderFileListProps) => (
  <>
    {Array.from(files.keys()).map(id => {
      const fileOrError = files.get(id);
      if (!fileOrError) return null;
      return (
        <Item
          key={id}
          file={"file" in fileOrError ? fileOrError.file : fileOrError}
          onDelete={() => onDelete(id)}
          error={"error" in fileOrError ? fileOrError.error : undefined}
          onReselect={onReselect ? () => onReselect?.(id) : undefined}
          processing={processing}
          variant={listVariant}
        />
      );
    })}
  </>
);

export default UploaderFileList;
